module.exports = __webpack_public_path__ + "static/logo-pp-properti-29ccf9031a4c26452ff446501172d22d.png";